import React from "react";
import { ContextMenu, ContextMenuTrigger } from "react-contextmenu";

import "./ContextualFormatter.css";

export const contextualFormatter = (cell, row, key, content) => {
  const rowKeyValue = row ? row[key] : null;

  if (rowKeyValue === undefined || rowKeyValue === null) {
    return <span>{cell}</span>;
  }

  const menuId = `ctx-${rowKeyValue}`;

  return (
    <>
      <ContextMenuTrigger id={menuId} holdToDisplay={-1}>
        <span className="context-cell">{cell}</span>
      </ContextMenuTrigger>

      <ContextMenu id={menuId}>
        {content(row)}
      </ContextMenu>
    </>
  );
};